// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
require('es6-promise').polyfill()
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import './common/js/common'
import './directive/directive'
import './vendor/js/px2rem'
import './common/css/common.less'
import './vendor/css/flex.css'
import './vendor/css/animate.css'
import './vendor/css/base.css'
import {setSessionStorage,authMethods} from './common/js/auth'
import Cube from 'cube-ui'
import {Toast} from 'cube-ui'
import store from '@/vuex'
import Cookies from 'js-cookie';
import VueLazyLoad from 'vue-lazyload'


// import {Style,Button,Loading,Toast,Scroll,Input} from 'cube-ui'

// Vue.use(VueClipboards);
// Vue.use(Button,Loading,Toast,Scroll,Input);
// Vue.use(Button);
// Vue.use(Loading);
Vue.use(Toast);
// Vue.use(Scroll);
// Vue.use(Input);
Vue.use(Cube)
Vue.use(VueLazyLoad)

Vue.prototype.Cookies=Cookies;

Vue.prototype.Toast= (text='',type='correct',mask=true,time=2000)=>{
  console.log(Vue.prototype.$createToast)
  let toast = Toast.$create({
    time: time,
    mask:mask,
    txt: text,
    type:type
  });
  console.log(toast)
  return toast
}
// setSessionStorage();

Vue.config.productionTip = false
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js